<template>
  <div class="App-Forgot-Sent" txt-center>
    <div txt-center>
      <el-image lazy m-t-2 :style="`width: 230px;`" :src="img"></el-image>
    </div>
    <h2 f-w-600 m-tb-0 txt-center>Check Your Email Inbox.</h2>
    <p m-tb-0>Instructions were sent!</p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import img from "@/assets/illustrations/forgot-password.svg";

// import CheckEmailImage
@Options({
  components: {},
})
export default class extends Vue {
  img = img;
}
</script>

<style lang="scss">
.App-Forgot-Sent {
  .el-image {
    padding: 20px;
  }
}
</style>
